module.exports = __webpack_public_path__ + "img/right-arrow.8f01dc1b.svg";